var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWhitecheck = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 7.57,
  height: 5.797,
  viewBox: "0 0 7.57 5.797"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "Icon_ionic-ios-checkmark",
  "data-name": "Icon ionic-ios-checkmark",
  d: "M17.965,12.885l-.619-.636a.133.133,0,0,0-.1-.042h0a.128.128,0,0,0-.1.042L12.86,16.569,11.3,15.008a.136.136,0,0,0-.2,0l-.626.626a.14.14,0,0,0,0,.2L12.445,17.8a.623.623,0,0,0,.411.2.652.652,0,0,0,.408-.193h0l4.7-4.725A.15.15,0,0,0,17.965,12.885Z",
  transform: "translate(-10.434 -12.206)",
  fill: "#fff"
})));
export { SvgWhitecheck as ReactComponent };
export default __webpack_public_path__ + "static/media/whitecheck.739e86ef1715c03c133238005ec08add.svg";